import { useState } from "react";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ECourseStatus } from "../../../../../@types";
import { useMyCourseInstructor } from "../../hooks/useMyCourseInstructor";

export function MyCourseRemove() {
	const { course, updateCourseStatus } = useMyCourseInstructor();
	const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] = useState(false);
	const navigate = useNavigate();

	if (!course) {
		return null;
	}

	const onClickDeleteCourse = async () => {
		onClickCloseConfirmDeleteDialog();
		await updateCourseStatus(ECourseStatus.REMOVE);
		navigate("/training/my-services");
	};

	const onClickOpenConfirmDeleteDialog = () => {
		setConfirmDeleteDialogOpen(true);
	};

	const onClickCloseConfirmDeleteDialog = () => {
		setConfirmDeleteDialogOpen(false);
	};

	return (
		<div className="my-course-basic-info-container">
			<Typography className="small-title-text bold">Remove Service</Typography>
			<Typography className="normal-text item-separator-small">
				Note: Your students will still have access to your content.
			</Typography>
			<Button
				className="normal-button add-class-button black-button item-separator-big"
				onClick={onClickOpenConfirmDeleteDialog}>
				Remove your Service
			</Button>
			<Dialog
				open={confirmDeleteDialogOpen}
				className="confirm-dialog"
				onClose={onClickCloseConfirmDeleteDialog}>
				<DialogContent>
					<Typography className="normal-text">
						This action will permanently remove your service from our system. To
						keep your work, you can unpublish your service and make edits
						instead. Are you sure you want to proceed with permanently removing
						your service?
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button
						className="dialog-button"
						onClick={onClickCloseConfirmDeleteDialog}>
						Cancel
					</Button>
					<Button className="dialog-button" onClick={onClickDeleteCourse}>
						Yes, Remove Service
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
